/**
 * Obtiene o genera un ID único para el dispositivo actual
 * @returns {string} ID único del dispositivo
 */
export function getDeviceId() {
  // Intentar recuperar un ID existente del localStorage
  let deviceId = localStorage.getItem('epic_device_id');
  
  // Si no existe, crear uno nuevo usando crypto.randomUUID()
  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem('epic_device_id', deviceId);
  }
  
  return deviceId;
}

/**
 * Obtiene o genera un nombre para el dispositivo actual
 * @returns {string} Nombre del dispositivo
 */
export function getDeviceName() {
  // Intentar recuperar un nombre existente del localStorage
  let deviceName = localStorage.getItem('epic_device_name');
  
  // Si no existe, generar uno basado en el navegador/OS
  if (!deviceName) {
    const userAgent = navigator.userAgent;
    let browserInfo = "Desconocido";
    
    // Detectar navegador y sistema operativo
    if (userAgent.indexOf("Chrome") > -1) {
      browserInfo = "Chrome";
    } else if (userAgent.indexOf("Safari") > -1) {
      browserInfo = "Safari";
    } else if (userAgent.indexOf("Firefox") > -1) {
      browserInfo = "Firefox";
    } else if (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1) {
      browserInfo = "Internet Explorer";
    } else if (userAgent.indexOf("Edge") > -1) {
      browserInfo = "Edge";
    }
    
    // Detectar sistema operativo
    let osInfo = "";
    if (userAgent.indexOf("Win") > -1) {
      osInfo = "Windows";
    } else if (userAgent.indexOf("Mac") > -1) {
      osInfo = "MacOS";
    } else if (userAgent.indexOf("Linux") > -1) {
      osInfo = "Linux";
    } else if (userAgent.indexOf("Android") > -1) {
      osInfo = "Android";
    } else if (userAgent.indexOf("iOS") > -1 || userAgent.indexOf("iPhone") > -1 || userAgent.indexOf("iPad") > -1) {
      osInfo = "iOS";
    }
    
    deviceName = `${browserInfo} en ${osInfo}`;
    localStorage.setItem('epic_device_name', deviceName);
  }
  
  return deviceName;
}
